var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sa-tab-scroll"},[_c('b-card',{staticClass:"sa-card",attrs:{"header":"Terapia","header-tag":"header","footer-tag":"footer","title":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }